import {} from "services"
import useAppRoutes from "../useAppRoutes/useAppRoutes"
import useFeatureRoutes from "../useFeatureRoutes/useFeatureRoutes"
import useOrgGroupRoutes from "../useOrgGroupRoutes/useOrgGroupRoutes"

interface IDashboardRoutes {
    appDashboard: () => string
    bkDashboard: () => string
    bmDashboard: () => string
    currentOrgGroupDashboard: () => string
    mmbDashboard: () => string
    orgGroupDashboard: (orgGroupId: string) => string
    ppDashboard: () => string
}

const isValid = (id: string) => !!id && id.length > 0

/**
 * Hook for generating dashboard routes based on the current application context.
 *
 * @returns An object containing functions to generate dashboard routes.
 */
const useDashboardRoutes = (): IDashboardRoutes => {
    const { rootRoute } = useAppRoutes()
    const { currentOrgGroup } = useOrgGroupRoutes()

    const {
        brewKnowledgeFeatureRoute,
        brewMenuFeatureRoute,
        marketMyBreweryFeatureRoute,
        performancePlatformFeatureRoute
    } = useFeatureRoutes()

    const appDashboard = () => rootRoute()

    const currentOrgGroupDashboard = () => `${currentOrgGroup()}/dashboard`
    const orgGroupDashboard = (orgGroupId) => `${rootRoute()}/${orgGroupId}/dashboard`

    // Passing through feature route as 'dashboard' to maintain consistency with prior configuration
    return {
        appDashboard,
        bkDashboard: brewKnowledgeFeatureRoute,
        bmDashboard: brewMenuFeatureRoute,
        currentOrgGroupDashboard,
        mmbDashboard: marketMyBreweryFeatureRoute,
        orgGroupDashboard,
        ppDashboard: performancePlatformFeatureRoute
    }
}

export default useDashboardRoutes
